module.exports = __webpack_public_path__ + "media/כו.393ba751.mp3";